import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { conversationsActions } from 'features/conversations';

const useConversations = () => {
  const dispatch = useDispatch();
  const getConversations = useCallback(({ offset, patient_id, source }) => dispatch(conversationsActions.getConversations({ offset, patient_id, source })), [dispatch]);
  const getConversation = useCallback((id) => dispatch(conversationsActions.getConversation(id)), [dispatch]);
  const updateConversation = useCallback(conversation => dispatch(conversationsActions.updateConversation(conversation)), [dispatch]);
  const setDevMode = useCallback(() => dispatch(conversationsActions.setDevMode()), [dispatch]);
  const clearLocalConversations = useCallback(() => dispatch(conversationsActions.clearLocalConversations()), [dispatch]);
  const clearLocalActiveConversation = useCallback(() => dispatch(conversationsActions.clearLocalActiveConversation()), [dispatch]);

  return { 
    getConversations, 
    getConversation, 
    updateConversation,
    setDevMode,
    clearLocalConversations,
    clearLocalActiveConversation
  };
};

export default useConversations;